export default __webpack_public_path__ + "static/media/tt-logo.d9b9b04f.svg";